<template>
  <a
    :href="product_url ? product_url : 'javascript:;'"
    class="ins-dot"
    :class="{
      'ins-dot-show': active,
      'show-some-index': show_some_index == ins_dot_index,
    }"
    :style="dot_style"
  >
    <div @mouseenter="mouseenter" @mouseleave="mouseleave">
      <span class="ins-dot-index">{{ ins_dot_index + 1 }}</span>
      <div class="ins-dot-info">
        <span>
          {{ ins_dot && ins_dot.product && ins_dot.product.title }}
        </span>
        <span>
          <v-selectprice
            :price="this.product_price || 0"
            :font-size="12"
            :disable_select="true"
            :country="$store.state.pricetype"
          ></v-selectprice>
        </span>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    ins_dot: {},
    ins_dot_index: {},
    show_some_index: {},
  },
  data() {
    return {
      active: false,
      product_url: null,
      product_price: 0,
      dot_style: {},
    };
  },
  watch: {
    ins_dot: {
      handler(newV) {
        let { product, variant, variant_id, location_x, location_y } = newV;
        this.dot_style = {
          top: location_y * 100 + "%",
          left: location_x * 100 + "%",
        };
        if (product && product.path) {
          this.product_url = product.path;
        }
        if (this.product_url && variant_id) {
          this.product_url = this.product_url + "?&variant=" + variant_id;
        }
        if (variant && variant.price) {
          this.product_price = variant.price;
        } else if (product && product.price) {
          this.product_price = product.price;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    mouseenter() {
      this.active = true;
    },
    mouseleave() {
      this.active = false;
    },
  },
};
</script>
<style scoped lang='scss'>
.ins-dot {
  position: absolute;
  width: 0;
  height: 0;
  text-align: center;
  overflow: visible;
  .ins-dot-index {
    color: #333333;
    background: #ffffff;
    border: solid 1px #333333;
    position: relative;
    display: block;
    margin: 0 auto;
    box-shadow: 0 1px 3px rgb(0 0 0 / 50%);
    width: 24px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    border-radius: 50%;
    opacity: 0;
    visibility: hidden;
    -webkit-transform: translate(-50%, -40%);
    -moz-transform: translate(-50%, -40%);
    transform: translate(-50%, -40%);
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    overflow: hidden;
  }
  .ins-dot-info {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    margin: 0;
    padding: 5px 10px;
    color: #000;
    font-size: 11px;
    line-height: 15px;
    text-align: left;
    border-radius: 3px;
    background: #ffffff;
    box-shadow: 0 1px 3px rgb(0 0 0 / 50%);
    opacity: 0;
    visibility: hidden;
    z-index: 999999;
    -webkit-transform: translate(-50%, 30px);
    -moz-transform: translate(-50%, 30px);
    transform: translate(-50%, 30px);
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    &::before {
      border-bottom: solid 8px #ffffff;
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      display: block;
      margin: 0 auto;
      padding: 0;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #ffffff;
      -webkit-transform: translate(-50%, -100%);
      -moz-transform: translate(-50%, -100%);
      transform: translate(-50%, -100%);
    }
    &::after {
      content: "";
      position: absolute;
      top: -24px;
      left: 0;
      right: 0;
      bottom: 0;
      background: transparent;
    }
    span {
      display: block;
      font-size: 11px;
      line-height: 15px;
      font-weight: normal;
      white-space: nowrap;
    }
  }
}
.ins-dot-show {
  .ins-dot-index {
    visibility: hidden !important;
    opacity: 0 !important;
  }
  .ins-dot-info {
    opacity: 1;
    visibility: visible;
    -webkit-transform: translate(-50%, 20px);
    -moz-transform: translate(-50%, 20px);
    transform: translate(-50%, 20px);
  }
}
.show-some-index {
  .ins-dot-index {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 768px) {
  .ins-dot {
    .ins-dot-index {
      opacity: 1 !important;
      visibility: visible !important;
    }
    .ins-dot-info {
      opacity: 0 !important;
      visibility: hidden !important;
      display: none !important;
    }
  }
}
</style>